import React from 'react'
import Header from '../../Components/Header/Header'
import Footer from '../../Components/Footer/Footer'
import img1 from '../../assets/course/12101001.jpg'
import img2 from '../../assets/course/12101002.jpg'
import img3 from '../../assets/course/12101003.jpg'
import tr1 from '../../assets/others/11102067.webp'
import img4 from '../../assets/others/11102069.jpg'
import cr1 from "../../assets/course/image-1.png"
import cr2 from "../../assets/course/image-1.png"
import cr3 from "../../assets/course/image-1.png"
import cr4 from "../../assets/course/image-1.png"
import cr5 from "../../assets/course/image-1.png"
import Accordion from 'react-bootstrap/Accordion'
import Companysec from '../../Components/Companysec/Companysec'
import Offersec from '../../Components/Offersec/Offersec'
import icncheck from '../../assets/icons/check-circle-bl.svg'
import instimg from '../../assets/others/11102038.jpg'
import Enrollaction from '../../Components/Enrollaction/Enrollaction'
import "react-multi-carousel/lib/styles.css";
import Partnersec from '../../Components/Partnersec/Partnersec'
import Videoreview from '../../Components/Videoreviewsec/Videoreview'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import Whysec from '../../Components/Whysec/Whysec'
library.add(fas)

const onButtonpdf = () => {
    const pdfUrl = "../../brochuer/Analog-Circuit-Design-Brochure.pdf";
    window.open(pdfUrl);
};

const Analogcircuit = () => {
    const faqSchema={
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "Is this Analog Circuit Design Training suitable for beginners?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, Analog Circuit Design Training&#x20;&#x69;s valid for both, whether you are a professional or a beginner. Our cruise is designed to cover the basics and then move towards the complex topic. Hence, freshers or professionals can establish a solid base in VLSI analog circuit design."
      }
    },
    {
      "@type": "Question",
      "name": "What career opportunities are available after this course?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "After completing ou&#x72;&#x20;Analog Circuit Design Course, you will be ready for positions in Analog & Mixed-Signal Design, Standard Cell Design, I/O Design, and many more departments. Our team will assist you, and with sought-after skills, you will reach your life’s objective."
      }
    },
    {
      "@type": "Question",
      "name": "What can I get from your Analog Circuit Design Course?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Our course covers everything from the basics to the advanced aspects o&#x66;&#x20;VLSI analog circuit design. You will gain knowledge from modeling MOSFETs to creating complex analog circuits. It enhances your practical abilities, such as utilizing EDA tools for simulation and verification, allowing you to handle projects effectively in the real world."
      }
    },
    {
      "@type": "Question",
      "name": "What subjects will be included in the VLSI Analog Circuit Design Course?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The VLSI Analog Circuit Design Course will cover a range of subjects, starting from fundamental semiconductor physics to complex analog block design. Important topics consist of modeling MOSFETs, single and differential amplifier analysis, designing operational amplifiers, and constructing intricate circuits such as Phase-Locked Loops (PLLs) and Bandgap references."
      }
    },
    {
      "@type": "Question",
      "name": "What makes this Analog Circuit Design Course ideal for career growth?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "You will learn Analog Circuit Design, which makes you best with both fundamental and advanced skills. With industry-relevant projects, expert guidance, and 100% placement assistance, you will be well-prepared for various roles in analog and mixed-signal design, enhancing your career prospects."
      }
    },
    {
      "@type": "Question",
      "name": "Can professionals with experience join the VLSI Analog Circuit Design Course?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, Our VLSI Analog Circuit Design Course is perfect for professionals seeking to improve their knowledge and skills. The class offers a detailed understanding of advanced analog circuit design and focuses on enhancing abilities to stay competitive in the industry."
      }
    },
    {
      "@type": "Question",
      "name": "Will I get hands-on experience with industry-standard design tools?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. The course includes practical training on EDA tools, circuit simulation, design verification, and project execution to help learners gain real-world experience."
      }
    },
    {
      "@type": "Question",
      "name": "What types of analog circuits will I learn to design during the course?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "You will learn concepts related to amplifiers, current mirrors, voltage regulators, oscillators, PLLs, bandgap references, and other commonly used analog building blocks."
      }
    },
    {
      "@type": "Question",
      "name": "How does practical project work help in learning analog circuit design?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Project-based learning helps students apply theoretical concepts, improve problem-solving skills, and gain confidence in handling real design challenges. Takshila VLSI includes industry-oriented projects as part of the learning process."
      }
    },
    {
      "@type": "Question",
      "name": "What support is available for students preparing for analog design careers?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Students can benefit from technical mentoring, lab support, interview preparation, and career guidance. Takshila VLSI also provides placement assistance to help learners transition into industry roles."
      }
    }
  ]
};

const courseSchema ={
  "@context": "https://schema.org",
  "@type": "Course",
  "@id": "https://www.takshila-vlsi.com/analog-circuit-design/#course",
  "name": "Analog Circuit Design Training Course",
  "description": "Analog Circuit Design training covering MOSFET modelling, analog circuit design, EDA tools, simulation and verification of analog and mixed-signal circuits including amplifiers, Opamps, PLLs, Bandgap references, LDOs, oscillators and data converters.",
  "url": "https://www.takshila-vlsi.com/analog-circuit-design/",
  "provider": {
    "@type": "Organization",
    "name": "Takshila VLSI",
    "url": "https://www.takshila-vlsi.com/",
    "logo": {
      "@type": "ImageObject",
      "url": "https://www.takshila-vlsi.com/static/media/Logo-2.8ea769c5a593c38a2ba7.jpg"
    },
    "email": "info@takshila-vlsi.com",
    "telephone": "+91-9742972744"
  },
  "coursePrerequisites": "B.E/B.Tech in ECE/EEE, or M.E/M.Tech/M.S in VLSI, Embedded Systems or Microelectronics. Working professionals in the semiconductor industry can also join.",
  "timeRequired": "P16W",
  "hasCourseInstance": {
    "@type": "CourseInstance",
    "courseMode": [
      "Online",
      "Offline"
    ],
    "location": [
      {
        "@type": "Place",
        "name": "Bengaluru"
      },
      {
        "@type": "Place",
        "name": "Hyderabad"
      }
    ],
    "courseWorkload": "P16W"
  },
  "instructor": {
    "@type": "Person",
    "name": "Mr. Sateesh",
    "jobTitle": "Analog Circuit Design Specialist"
  },
  "about": [
    "Analog Circuit Design",
    "Analog Integrated Circuit Design",
    "Analog Mixed-Signal Design",
    "MOSFET Modelling",
    "Analog Circuit Simulation",
    "EDA Tools",
    "CMOS Circuit Design",
    "Memory Design",
    "I/O Circuit Design",
    "Opamp Design",
    "PLL Design",
    "Bandgap Reference Design",
    "LDO Design",
    "Data Converters"
  ],
  "teaches": [
    "Device Physics",
    "Linux & Cadence Tool Introduction",
    "Single Stage Amplifiers Design",
    "Differential Amplifiers Design",
    "Feedback Techniques",
    "Stability Analysis",
    "Operational Amplifiers Design",
    "Voltage Regulators Design",
    "Bandgap References",
    "Oscillators",
    "Phase Locked Loops",
    "Data Converters",
    "Mini Project",
    "Mock Interviews & Personality Development"
  ]
};

  return (
    <div>
        <Helmet>
          <title>Analog Circuit Design VLSI Training Course & Fees | Takshila VLSI</title>
          <meta name="description" content="Enroll in Analog Circuit Design training to master amplifiers, biasing techniques, and CMOS design through expert-led, hands-on sessions with Takshila VLSI." />
          <link rel="canonical" href="https://www.takshila-vlsi.com/analog-circuit-design/" />
          <meta property="og:locale" content="en_US" />
          <meta property="og:type" content="article" />
          <meta property="og:title" content="Analog Circuit Design VLSI Training Course & Fees | Takshila VLSI" />
          <meta property="og:description" content="Enroll in Analog Circuit Design training to master amplifiers, biasing techniques, and CMOS design through expert-led, hands-on sessions with Takshila VLSI." />
          <meta property="og:url" content="https://www.takshila-vlsi.com/analog-circuit-design/" />
          <meta property="og:site_name" content="Takshila VLSI" />
          <meta property="article:modified_time" content="2024-08-08T06:48:43+00:00" />
          <meta property="og:image" content="https://www.takshila-vlsi.com/wp-content/uploads/2019/08/Analog-Circuit-Design.jpg" />
          <meta property="og:image:width" content="1000" />
          <meta property="og:image:height" content="675" />
          <meta property="og:image:type" content="image/jpeg" />
          <meta name="twitter:card" content="summary_large_image" />

          <script type="application/ld+json">
                {JSON.stringify(faqSchema)}
                </script>
                <script type="application/ld+json">
                {JSON.stringify(courseSchema)}
                </script>

        </Helmet>
    <Header/>
      <main>
          <section class="section-banner pg-banner ws-section pt-5 bg-14">
          <div class="container text-center">
                      <div class="row justify-content-around p-lg-5 pb-0">
                          <div class="col-md-9">
                              <div class="pg-title-sec">
                                  <h1 className='pg-title pb-3'>Analog Circuit 
                                  <span className='bg-txt mx-3'>Design</span> 
                                  </h1>
                                  <p className='pg-title-desc mb-5'>Takshila VLSI institute is among the top 10 VLSI training institutes in India. At Takshila, we understand the changing demands in the field of VLSI.</p>
                              </div>
                          </div>
                          <div class="col-md-12 align-self-center mb-3">
                                  <a href="/register-now">
                                      <button class="btn-primary btn-icon">Enroll Now<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
                                  </a>
                          </div>
                      </div>
                      <div class="row justify-content-center img-radius g-3">
                          <div class="col-md-2 align-self-end d-none d-sm-block">
                          <img src={img1} alt=''/>
                          </div>
                          <div class="col-md-2 align-self-end">
                          <div className='course-bnr-bx bg-8 radius-1'>
                                  <h4 className='course-bnr-title'>100%</h4>
                                  <p className='course-bnr-desc'>Learners feel more confident when applying for jobs</p>
                              </div>
                          </div>
                          <div class="col-md-3 align-self-end">
                          <img src={img2} alt=''/>
                          </div>
                          <div class="col-md-2 align-self-end">
                          <div className='course-bnr-bx bg-7 radius-1'>
                                  <h4 className='course-bnr-title'>100%</h4>
                                  <p className='course-bnr-desc'>Learners became better at their job</p>
                              </div>
                          
                          </div>
                          <div class="col-md-2 align-self-end d-none d-sm-block">
                          <img src={img3} alt=''/>
                          </div>
                      </div>
          </div>
      </section>
      <section className='course-desc p-lg-5 bg-14 pt-5'>
              <div class="container text-center">
                      <div class="row justify-content-around text-center">
                          <div class="col-md p-lg-5">
                                  <h2 className='ws-section_heading pd-03'><span className='font-thin'>Analog Circuit Design Courses & Analog Design Training
                                  </span> Courses in Bangalore/ Hyderabad</h2>
                          </div>
                      </div>
                      <div class="row justify-content-around">
                          <div class="col-md">
                                  <h3 className='pb-3 txt-3'>COURSE DESCRIPTION</h3>
                                  <div className='text-left text-xl'>
                                  <p>Primarily this course is designed to cover very important basics of Analog Integrated Circuit design. This course covers all the way from MOSFET modelling to Complex Analog Block designs. Mainly focused on giving hands-on practical exposure in doing circuit design for a given analog &amp; mixed signal product. By end of the course you will learn circuit design in EDA tool, simulation, design verification of typical analog circuits such as Opamp, PLL, Bandgap, LDO.</p>
                                  <p>Course also focus on giving insights of the design and simulation of I/O’s, Memory as well. After completing the course, you will get opportunity to move into domains such as Analog &amp; Mixed Signal Design, Memory Design, Standard Cell Design, and I/O Design.</p>
                                  </div>
                          </div>
                      </div>
              </div>
      </section>
      <section className='highlight-section p-lg-5 bg-14 p-2'>
          <div class="container bg-9 p-lg-5 p-3 radius-1">
              <div className='mb-5'>
              <div className='txt-2 mb-2'>Eligibility</div>
              <div class="row row-cols-2">
                  <div className='col-lg'>
                  <div className='icon-left-bx d-flex'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>B.E/B.Tech in ECE/EEE.</div>
                  </div>
                  </div>
                  <div className='col-lg'>
                  <div className='icon-left-bx d-flex'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>M.E/M.Tech/M.S in VLSI/Embedded/Microelectronics
pursuing or completed.
Working professionals in Semiconductor industry.
                      </div>
                  </div>
                  </div>
              </div>
              </div>
              <div className='mb-5'>
              <div className='txt-2 mb-2'>Course Duration</div>
              <div class="row row-cols-2">
                  <div className='col-lg'>
                  <div className='icon-left-bx d-flex'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>16 Weeks</div>
                  </div>
                  </div>
              
              </div>
              </div>
              <div>
              <div className='txt-2 mb-2'>Course Highlights</div>
              <div class="row">
                  <div className='col-lg'>
                  <div className='icon-left-bx d-flex mb-2'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>Deep understating MOSFETs W.r.t Modelling, Noise, Matching & Non- Linearity
                      </div>
                  </div>
              
                  <div className='icon-left-bx d-flex mb-2'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>Understand Analog Circuit Basics of Single Stage Amps, Differential Amps, Current Mirrors, Two Stage Opamp Design, Feedback Theory & Frequency Compensation
                      </div>
                  </div>
                  
                  <div className='icon-left-bx d-flex mb-2'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>Understand Critical Analog Blocks such as Band Gap reference Design, Oscillators, Phase Lock Loop Designs
                      </div>
                  </div>
                  
                  <div className='icon-left-bx d-flex mb-2'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>Critical Industry standard project execution under the guidance of 15+ year’s industry expert.
                      </div>
                  </div>
                  
                  <div className='icon-left-bx d-flex mb-2'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>24×7 Lab Support with classroom practice handouts and course material.
                      </div>
                  </div>
                  <div className='icon-left-bx d-flex mb-2'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>Soft skills development, job oriented analog design training with 100% placement assistance.
                      </div>
                  </div>
                  </div>
              </div>
              </div>
                  
          </div>
      </section>

      <section className='author-section p-lg-5 p-2 bg-14'>
      <div className='container'>
      <div class="row">
              <div class="col-lg-9 align-self-center bg-3 dark-bg p-lg-5 p-3 mr--10 mt-5 mb-3">
              <h2 class="ws-section_heading mb-3">About Instructors</h2>
              <a href='/teachers/sateesh/'><h4>Mr.Sateesh</h4></a>
              <h6 className='pb-3'>(Analog Circuit Design Specialist)</h6>
              <p>A VLSI Professional with 15+ years of rich experience in Analog Mixed-signal Circuit design. Worked with Tier 1 Semiconductor Product and Service companies and also Product based startup companies which helped me to understand the learning curves and business models.&nbsp;Having facilitative leadership skills and having a proven track record with leading teams on-site &amp; offshore design centers.</p>
              <div class="wpb_wrapper">
              <div class="row g-3">
                      <div class="col-lg m-lg-3 p-4 bg-white radius-1">
                      <p><strong>Expertise Areas:</strong></p>
                      <ul>
                      <li>AMS IP design.</li>
                      <li>DC/DC Converters Design.</li>
                      <li>Memory design.</li>
                      <li>Full chip / Block integration.</li>
                      </ul>

                        <p><strong>Technology Process Worked On:</strong></p>
                      </div>
                      <div class="col-lg m-lg-3 p-4 bg-white radius-1">
                      <p><strong>Finfet Technologies:</strong> 7nm, 10nm, 14nm, 16nm, and 22nm.<strong><br/>
                      Nominal Technologies: </strong>28nm, 32nm, 40nm, 65nm, 90nm,130nm, 180nm &amp; 440nm.<br/>
                      <strong><br/>
                      IC Foundries Worked with:&nbsp;</strong>TSMC,&nbsp;UMC,&nbsp;GF, SAMSUNG, ST, INTEL</p>
                      </div>
                      
                  </div>
                      </div>
              </div>
              <div class="col-lg img-radius">
              <img src={instimg} alt=''/>
              </div>
          </div>
          </div>
      </section>

      <section className='curriculum-section pt-5'>
          <div className='container'>
              <div class="row justify-content-center mb-5">
              <div class="col-lg-8 text-center">
              <h3 class="ws-section_heading pb-03 txt-3">IC Design Training / Chip Design training / Custom Circuit Design Training
              </h3>
              </div>
              </div>
              <div class="row mb-5">
                  <div class="col-lg-8">
                  <div class="ws-section_heading pb-03 txt-3 mb-lg-0">Course Curriculum</div>
                  </div>
                  <div class="col-lg-4 align-self-center">
                 <button class="btn-primary btn-icon" onClick={onButtonpdf}>Download Brouchure<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
                  
                  </div>
              </div>
              <div className='row'>
                  <div className='col-lg'>
                  <div className='curriculum-accord accordion'>
                          <Accordion defaultActiveKey="0">
                          <Accordion.Item eventKey="0">
                              <Accordion.Header>Module 1: Device Physics</Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Semiconductor Basics</div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>MOSFET, BJT & Diode Basics</div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Small Signal Models </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Short Channel Effects </div>
                              </div>
                          </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="1">
                              <Accordion.Header>Module 2: Linux & Cadence Tool Introduction</Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Basics of UNIX/LINUX</div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Schematic Capture Introduction</div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Different Analysis Introduction</div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Running Simulations Introduction</div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="2">
                              <Accordion.Header>Module 3: Single stage Amplifiers Design</Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Common Source, Common Gate & Source Follower Designs</div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Cascode Stages Design 
                              </div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="3">
                              <Accordion.Header>Module 4: Differential Amplifiers Design</Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Single Ended Vs Differential Design
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Differential Amplifier Analysis
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Current Mirrors
                              </div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="4">
                              <Accordion.Header>Module 5: Feedback Techniques</Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Differerent Feedback Topologies
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Feedback Practical Application
                                  </div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="5">
                              <Accordion.Header>Module 6: Stability Analysis</Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Stability Analysis & Frequency compensation
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Compensation of Feedback systems
                              </div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="6">
                              <Accordion.Header>Module 7: Operational Amplifiers Design</Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Single stage & Two stage Opamp design
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Folded Cascode & Gain Boosting Opamp design
                              </div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="7">
                              <Accordion.Header>Module 8: Voltage Regulators Design</Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Voltage Regulator Concepts
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Low Drop out regulator design
                              </div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="8">
                              <Accordion.Header>Module 9: Bangap References</Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Temperature Independent References Concepts
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Bandgap Reference Design
                              </div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="9">
                              <Accordion.Header>Module 10: Oscillators
                              </Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Positive Feedback Concepts
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Oscillator Design - Ring, LC & VCO 
                              </div>
                              </div>
                              </Accordion.Body>
                             
                          </Accordion.Item>
                          <Accordion.Item eventKey="10">
                              <Accordion.Header>Module 11: Phase Locked Loops
                              </Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Phase Locked Loops</div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>PLL Design</div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="11">
                              <Accordion.Header>Module 12: Data Converters
                              </Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Data Converter Concepts</div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Data Converters Design - Flash, SAR, Dual Slope</div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="11">
                              <Accordion.Header>Module 12: Mini Project
                              </Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Industry standard Mini Project</div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="12">
                              <Accordion.Header>Module 13: Mock Interviews & Personality Development
                              </Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Mock Interview's & Resume Building</div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Course completion test</div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          
                          </Accordion>
                          </div>
                  </div>
              </div>

          </div>
                  </section>

                  <section className='video-section p-lg-5 pt-4'>
          <div class="container text-center">
              <div className='row'>
                  <div className='col-lg text-center'>
                  <h2 class="ws-section_heading">Analog Circuit Design Demo Videos
                  </h2>
              </div>
              </div>
              <div class="row justify-content-center">
                  <div class="col-lg-4">
                      <iframe
                          width="100%"
                          height="250"
                          src={`https://www.youtube.com/embed/XVQ7wdhktB4`}
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                          title="Embedded youtube"
                          poster="hqdefault"
                      />
                  </div>
                  <div class="col-lg-4">
                  <iframe
                      width="100%"
                      height="250"
                      src={`https://www.youtube.com/embed/K626f7eMyEY`}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      title="Embedded youtube"
                      poster="hqdefault"
                  />
                  </div>
              </div>
          </div>
      </section>


                  <Companysec/>
                  <section className='ws-section pb-5 bg-white'>
                      <div class="container text-center">
                      <div class="row justify-content-around">
                                      <div class="col-lg-6">
                                          <div className='trainer-box mb-3'>
                                          
                                              <div className='trainer-img img-radius'>
                                              <img src={tr1} alt=''/>
                                              </div>
                                          </div>
                                      </div>
                                      <div class="col-lg-6 text-left">
                                          <h2 className='mb-4'>4 Top Reasons Why You Must Sign Up For Our Analog Circuit Design Course Right NOW!
                                          </h2>
                                          <p>Analog Circuit Design concentrates on design of Signal Amplifiers, Power Management, Data Converters, Clocks and Interfaces, Wireless and RF Communication Products. Analog designers are qualified electrical engineers. Their job, in a nutshell, is to ensure that this complex integrated circuitry keeps performing consistently. Experts describe the analog design process as one of taking a collection of properties, physical constraints of supply, temperature, and process capabilities, as well as desired performance specifications, and skillfully creating a functional system that features all of the properties. And this is precisely what our analog circuit design training is all about.</p>
                                          <p>Our analog circuit design course is primarily designed to cover all of the crucial basics of the design of analog integrated circuits. The course covers from MOSFET modeling right up to Complex Analog Block designs. Focused mainly on providing hands-on and practical exposure in executing circuit design for given mixed as well as analog products. By the time you complete this course, you would have mastered circuit design in EDA tools, design verification of usual analog circuits like PLL, LDO, Opamp, Bandgap, as well as simulation. Some of the topmost reasons why you must register for this course right now include;</p>
                                          <div className='course-accord dark-bg'>
                                      <Accordion defaultActiveKey="0">
                                      <Accordion.Item eventKey="0">
                                          <Accordion.Header>1. Varying Training under the Same Course</Accordion.Header>
                                          <Accordion.Body>
                                          <p>Experts have noted that modern integrated circuits are capable of holding many hundreds of millions of components on an area that is no more than the size of a fingertip. We have varying training under this single course which is most relevant to the world’s present level of technological advancement. Some of our foremost training here include;</p>
                                          <ul>
                                          <li>Our famous CMOS circuit design training.</li>
                                          <li>Our analog and mixed signal training.</li>
                                          <li>Our IO circuit design training.</li>
                                          <li>Our memory design training.</li>
                                          </ul>
                                          </Accordion.Body>
                                      </Accordion.Item>
                                      <Accordion.Item eventKey="1">
                                          <Accordion.Header>2. We Have the Foremost Analog and Mixed Signal Training Institutes
                                          </Accordion.Header>
                                          <Accordion.Body>
                                          <p>We run some of the best VLSI training centers in some of the best possible locations around the world. These institutes house the foremost analog and mixed signal training institutes you can ever find. At these institutes, we use the most superior training methodologies and infrastructure to teach our students. Our trainers are the foremost experts of the entire industry from around the whole world and they design our training programs in line with job and career growth opportunities that are presently available in the industry.</p>
                                          </Accordion.Body>
                                      </Accordion.Item>
                                      <Accordion.Item eventKey="2">
                                          <Accordion.Header>3. Top Features of the Course</Accordion.Header>
                                          <Accordion.Body>
                                          <p>Even the key features that are offered by the course are sufficient to make every single person join. If you go through varying analog circuit design courses online, you will discover that ours is the one that offers the most unique features in the entire industry. Some of the amazing features of our course include;</p>
                                          <ul>
                                          <li>Truly deep knowledge of Noise, MOSFET’s W.r.t. Modeling, Matching, and Non-Linearity.</li>
                                          <li>A complete understanding of Critical Analog Blocks like Oscillators, Band Gap Reference Design, Phase Lock Loop Design, and so on.</li>
                                          <li>24/7 Laboratory Support together with classroom practical, full course materials, and practice handouts.</li>
                                          <li>A complete understanding of Analog Circuit Basics of Differential Amps, Two-Stage Opamp Design, Frequency Compensation, Single Stage Amps, Current Mirrors, and Feedback Theory.</li>
                                          <li>Critical project execution that meets all industry standards under the capable guidance of industry experts who have more than fifteen years’ experience.</li>
                                          <li>The development of crucial soft skills, job oriented training in analog circuit design, together with 100% placement assistance after the completion of studies.</li>
                                          </ul>
                                          </Accordion.Body>
                                      </Accordion.Item>
                                      <Accordion.Item eventKey="3">
                                          <Accordion.Header>4. Eligibility</Accordion.Header>
                                          <Accordion.Body>
                                          <p>The eligibility criteria that you need to be able to register for this course is one that virtually everybody has. The two major eligibility criteria that can qualify you to register are;</p>
                                          <ol>
                                          <li>M.E., M. Tech., or M.S. in VLSI System Design, Embedded Systems, or Digital Electronics.</li>
                                          <li>B.E. or B. Tech. in ECE or EEE.</li>
                                          </ol>
                                          <p>The most popular and most convenient path you can follow to learn analog circuit design is via our program in which you even get 100% placement after your studies. We even offer analog circuit design courses online to make it easy and convenient for corporate executives and their employees to learn right from their sitting room.</p>
                                          <p>These are the foremost reasons that make our analog circuit design course a must for all that desire progress for their lives.</p>
                                          </Accordion.Body>
                                      </Accordion.Item>
                                      
                                      </Accordion>
                                      </div>
                                      </div>
                                  </div>
                      </div>
                  </section>
                  
      <Whysec/>           
      <Offersec/>

      <section className='corejob-section p-lg-5 bg-14 pt-4'>
              <div class="container text-center">
                              <div className='row pb-3'>
                                  <div className='col-lg text-center'>
                                  <h2 class="ws-section_heading">Core Job Opportunities</h2>
                              </div>
                              </div>
                              <div className='row g-3'>
                                  <div className='col-lg-4 mb-lg-4'>
                                  <div class="career-box d-flex p-3 radius-1 dark-bg">
                                              <img src={cr1} alt="movie" />
                                              <h6>Physical Design Engineering</h6>
                                              </div>
                                  </div>
                                  <div className='col-lg-4'>
                                  <div class="career-box d-flex p-3 radius-1 dark-bg">
                                              <img src={cr2} alt="movie" />
                                              <h6>Physical Design Engineering</h6>
                                              </div>
                                  </div>
                                  <div className='col-lg-4'>
                                  <div class="career-box d-flex p-3 radius-1 dark-bg">
                                              <img src={cr3} alt="movie" />
                                              <h6>Physical Design Engineering</h6>
                                              </div>
                                  </div>
                                  <div className='col-lg-4'>
                                  <div class="career-box d-flex p-3 radius-1 dark-bg">
                                              <img src={cr4} alt="movie" />
                                              <h6>Physical Design Engineering</h6>
                                              </div>
                                  </div>
                                  <div className='col-lg-4'>
                                  <div class="career-box d-flex p-3 radius-1 dark-bg">
                                              <img src={cr5} alt="movie" />
                                              <h6>Physical Design Engineering</h6>
                                              </div>
                                  </div>
                                  <div className='col-lg-4'>
                                  <div class="career-box d-flex p-3 radius-1 dark-bg">
                                              <img src={cr1} alt="movie" />
                                              <h6>Physical Design Engineering</h6>
                                              </div>
                                  </div>
                              </div>
                          </div>
      </section>

      <section className='ws-section pb-5 bg-white'>
          <div class="container text-center">
          <div className='row pb-3'>
                  <div className='col-lg text-center'>
                  <h2 class="ws-section_heading">Connect With Us</h2>
              </div>
              </div>
          <div class="row justify-content-around">
                          <div class="col-lg-5">
                              <div className='trainer-box'>
                                  <div className='content-box wd-80 d-flex bg-path'>
                                  <div className='trainer-content'>
                                  <h5 className='trainer-title text-left'>Join us & achieve <br/>
                                  your goals.</h5>
                                  </div>
                                  </div>
                                  <div className='trainer-img img-radius'>
                                  <img src={img4} alt=''/>
                                  </div>
                              </div>
                          </div>
                          <div class="col-lg-6">
                              
                              <iframe
                                  aria-label='Register Now'
                                  width="100%"
                                  height="850"
                                  src={`https://forms.zohopublic.in/takshilavlsi/form/RegisterNow/formperma/tlJf9hR_tSfj9rMVkXThsxg_XdK_F2MPKQIOi3mqwE4`}
                                  frameborder="0" 
                              
                              />
                          
                          </div>
                      </div>
          </div>
      </section>

      
      <section className='course-faq-section ws-section p-lg-5 bg-14'>
          <div className='container'>
              <div className='row'>
                  <div className='col-lg text-center'>
                  <h2 class="ws-section_heading">Frequently Asked Questions</h2>
              </div>
              </div>
              <div className='row justify-content-center pb-5'>
                  <div className='col-lg-10'>
                  <Accordion defaultActiveKey="0">
                          <Accordion.Item eventKey="0">
                              <Accordion.Header>1. Is this Analog Circuit Design Training suitable for beginners?</Accordion.Header>
                              <Accordion.Body>
                                <p>Yes, <strong>Analog Circuit Design Training </strong>is valid for both, whether you are a professional or a beginner. Our cruise is designed to cover the basics and then move towards the complex topic. Hence, freshers or professionals can establish a solid base in VLSI analog circuit design.</p>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="1">
                              <Accordion.Header>2. What career opportunities are available after this course?</Accordion.Header>
                              <Accordion.Body>
                              <p>After completing our<strong> Analog Circuit Design Course</strong>, you will be ready for positions in Analog &amp; Mixed-Signal Design, Standard Cell Design, I/O Design, and many more departments. Our team will assist you, and with sought-after skills, you will reach your life’s objective.</p>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="2">
                              <Accordion.Header>3. What can I get from your Analog Circuit Design Course?</Accordion.Header>
                              <Accordion.Body>
                              <p>Our course covers everything from the basics to the advanced aspects of<strong> VLSI analog circuit design</strong>. You will gain knowledge from modeling MOSFETs to creating complex analog circuits. It enhances your practical abilities, such as utilizing EDA tools for simulation and verification, allowing you to handle projects effectively in the real world.</p>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="3">
                              <Accordion.Header>4. What subjects will be included in the VLSI Analog Circuit Design Course?</Accordion.Header>
                              <Accordion.Body>
                              <p>The <strong>VLSI Analog Circuit Design</strong> Course will cover a range of subjects, starting from fundamental semiconductor physics to complex analog block design. Important topics consist of modeling MOSFETs, single and differential amplifier analysis, designing operational amplifiers, and constructing intricate circuits such as Phase-Locked Loops (PLLs) and Bandgap references.</p>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="4">
                              <Accordion.Header>5. What makes this Analog Circuit Design Course ideal for career growth?</Accordion.Header>
                              <Accordion.Body>
                              <p>You will <strong>learn Analog Circuit Design</strong>, which makes you best with both fundamental and advanced skills. With industry-relevant projects, expert guidance, and 100% placement assistance, you will be well-prepared for various roles in analog and mixed-signal design, enhancing your career prospects.</p>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="5">
                              <Accordion.Header>6. Can professionals with experience join the VLSI Analog Circuit Design Course?</Accordion.Header>
                              <Accordion.Body>
                              <p>Yes, Our <strong>VLSI Analog Circuit Design Course</strong> is perfect for professionals seeking to improve their knowledge and skills. The class offers a detailed understanding of <strong>advanced analog circuit design</strong> and focuses on enhancing abilities to stay competitive in the industry.</p>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="6">
                              <Accordion.Header>7. Will I get hands-on experience with industry-standard design tools?</Accordion.Header>
                              <Accordion.Body>
Yes. The course includes practical training on EDA tools, circuit simulation, design verification, and project execution to help learners gain real-world experience.
                           </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="7">
                              <Accordion.Header>8. What types of analog circuits will I learn to design during the course?</Accordion.Header>
                              <Accordion.Body>
You will learn concepts related to amplifiers, current mirrors, voltage regulators, oscillators, PLLs, bandgap references, and other commonly used analog building blocks.
</Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="8">
                              <Accordion.Header>9. How does practical project work help in learning analog circuit design?</Accordion.Header>
                              <Accordion.Body>
Project-based learning helps students apply theoretical concepts, improve problem-solving skills, and gain confidence in handling real design challenges. Takshila VLSI includes industry-oriented projects as part of the learning process.
</Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="9">
                              <Accordion.Header>10. What support is available for students preparing for analog design careers?</Accordion.Header>
                              <Accordion.Body>
Students can benefit from technical mentoring, lab support, interview preparation, and career guidance. Takshila VLSI also provides placement assistance to help learners transition into industry roles.
                           </Accordion.Body>
                          </Accordion.Item>
                          </Accordion>
                  </div>
              </div>
              <div class="row justify-content-center mt-lg-5">
                      <div class="col-lg-9">
                          <div class="callaction-2">
                              <div class="row">
                              <div class="col-lg-7">
                                  <h2>Don't see your questions ? answered here?</h2>
                              </div>
                              <div class="col-lg-4 align-self-center text-center">
                              <a href="/contact-us/">
                              <button class="btn-primary btn-icon ms-0" href="index.html#about">Contact Us<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
                              </a>
                              </div>
                              </div> 
                          </div>
                      </div>
                  </div>
          </div>
      </section>

      
      <Videoreview/>
      <Enrollaction/>
      <Partnersec/> 
      </main>
      <Footer/>
      </div>
  )
}

export default Analogcircuit